<template>
<v-container class="grey lighten-5">
    <v-row no-gutters>
    <v-col cols="12">
        <v-col sm="12" md="12" class="text-center">
        <v-layout row wrap>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs4></v-flex>
            <v-flex xs4>
            <h1 style="display:inline;" class="font-weight-thin mb-4">{{ $t("key-numbers") }}</h1>
            </v-flex>
        </v-layout>
        </v-col>
        <v-col sm="12" md="12">
            <v-card
                class="d-flex justify-center mb-6 bg-surface-variant"
                style="box-shadow: none;"
                flat
            >
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start key-number">{{ marchers }}</label>
                        <label class="align-end">{{ $t("marchers") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start key-number">{{ total_days }}</label>
                        <label class="align-end">{{ $t("total_days") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start key-number">{{ total_km }}</label>
                        <label class="align-end">{{ $t("total_km") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start key-number">{{ average_distance }}</label>
                        <label class="align-end">{{ $t("average_distance") }}</label>
                    </div>
                </v-card>
            </v-card>
            <!-- Below is th per day section -->
            <v-card
                v-if="showPerDay"
                class="d-flex justify-center mb-6 bg-surface-variant"
                style="box-shadow: none;"
                flat
            >
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start per-day-number">{{ total_km_day_1 }}</label>
                        <label class="align-end">{{ $t("day-1") }} {{ $t("total_km") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start per-day-number">{{ total_km_day_2 }}</label>
                        <label class="align-end">{{ $t("day-2") }} {{ $t("total_km") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start per-day-number">{{ total_km_day_3 }}</label>
                        <label class="align-end">{{ $t("day-3") }} {{ $t("total_km") }}</label>
                    </div>
                </v-card>
                <v-card
                    class="pa-2 key-tile"
                    style="box-shadow: none;"
                >
                    <div class="d-flex flex-column mb-6 bg-surface-variant">
                        <label class="align-start per-day-number">{{ total_km_day_4 }}</label>
                        <label class="align-end">{{ $t("day-4") }} {{ $t("total_km") }}</label>
                    </div>
                </v-card>
            </v-card>
        </v-col>
    </v-col>
    </v-row>  
</v-container>
</template>

<script>

export default {
name: "EventKeyNumbers",
components: {
    
},
props: {
    items: {
        required: true
    },
    search: {
        required: false
    },
    allItems: {
        type: Boolean,
        required: false,
        default: false
    },
    showPerDay: {
        type: Boolean,
        required: false,
        default: false
    }
},
data: () => ({
    results: [],
    marchers: 0,
    total_days: 0,
    total_km: 0,
    average_distance: 0,
    total_km_day_1: 0,
    total_km_day_2: 0,
    total_km_day_3: 0,
    total_km_day_4: 0,

}),
computed: {
    
},
methods: {
    runCalculations() {
        if (this.showPerDay == true) {
            this.calculatePerDayTotals()
        }
        this.calculateTotalMarchers();
        this.calculateTotalMarchDays();
        this.calculateAverage()
        this.calculateTotal()
        
    },
    calculateTotalMarchers() {
        this.marchers = this.items.length
        return this.items.length;
    },
    // Calculate how many individual marching days were done. Form example 1 from user A, 3 from user B and 4 from user C.
    calculateTotalMarchDays() {
        let days = 0;
        let results = this.items;
        for (let i = 0; i < results.length; i++) {
            if (results[i].accepted_1 == true) {
                days++;
            } 
            if (results[i].accepted_2 == true) {
                days++;
            } 
            if (results[i].accepted_3 == true) {
                days++;
            } 
            if (results[i].accepted_4 == true) {
                days++;
            }
        }
        this.total_days = days;
    },
    calculateAverage() {
        let total_km = this.calculateTotal()
        let total_marchers = this.calculateTotalMarchers()

        if (total_km != 0 || total_marchers != 0) {
            let average_distance = total_km / total_marchers;
            this.average_distance = this.formatNumber(average_distance, 1)
        } else {
            this.average_distance = 0;
        }
    },
    calculateTotal() {
        let total = 0;
        let results = this.items;
        for (let i = 0; i < results.length; i++) {
            total += results[i].total_distance
        }
        this.total_km = this.formatNumber(total, 0);
        
        return total;
    },
    calculatePerDayTotals() {
        let total_1 = 0;
        let total_2 = 0;
        let total_3 = 0;
        let total_4 = 0;
        let results = this.items;

        for (let i = 0; i < results.length; i++) {
            if (results[i].accepted_1) {
                total_1 += results[i].distance_1
            }
            if (results[i].accepted_2) {
                total_2 += results[i].distance_2
            }
            if (results[i].accepted_3) {
                total_3 += results[i].distance_3
            }
            if (results[i].accepted_4) {
                total_4 += results[i].distance_4
            }
        }
        this.total_km_day_1 = this.formatNumber(total_1, 1);
        this.total_km_day_2 = this.formatNumber(total_2, 1);
        this.total_km_day_3 = this.formatNumber(total_3, 1);
        this.total_km_day_4 = this.formatNumber(total_4, 1);
    },
    formatNumber (value, no){
      if(value == null){
        return "-"
      } else {
        return value.toFixed(no)
      }
    },
},
mounted() {
    this.runCalculations()
},
watch: {
    items: {
        handler () {
          this.runCalculations()
        },
        deep: true,
      }
  }
}
</script>

<style scoped>
.max-height {
    overflow:auto;
}
.key-number {
    color: crimson;
    font-size: xx-large;
}
.per-day-number {
    color: crimson;
    font-size: x-large;
}
.key-tile {
    color: crimson;
    margin-left: 50px;
    margin-right: 50px;
    border: 0;
}
</style>